import { computed, watch } from 'vue';
import { useThemeStore } from './store';
/**
 * 전역 테마 관리 컴포저블
 * 모든 앱에서 공유되는 테마 로직을 제공합니다.
 *
 * Store가 single source of truth이며, Store → DOM 단방향으로 동작합니다.
 */
export function useTheme() {
    const themeStore = useThemeStore();
    /**
     * document 요소에 data-theme 속성을 설정합니다.
     * Store 변경 시 자동으로 DOM에 반영됩니다.
     */
    const updateHtmlClass = () => {
        if (typeof document === 'undefined')
            return;
        const newTheme = themeStore.isDark ? 'dark' : 'light';
        document.documentElement.setAttribute('data-theme', newTheme);
    };
    // Store 변경 시 DOM에 자동 반영 (단방향 동기화)
    watch(() => themeStore.isDark, () => {
        updateHtmlClass();
    }, { immediate: true });
    // isDark는 Store 기반으로 제공 (single source of truth)
    const isDark = computed(() => themeStore.isDark);
    return {
        isDark,
        toggleTheme: themeStore.toggleTheme,
        setTheme: themeStore.setTheme,
        setSystemTheme: themeStore.setSystemTheme,
        updateHtmlClass,
    };
}
/**
 * 전역 테마 인스턴스 (싱글톤)
 */
let globalThemeInstance = null;
/**
 * 전역 테마 컴포저블 (싱글톤 패턴)
 * 앱 전체에서 동일한 테마 인스턴스를 공유합니다.
 */
export function useGlobalTheme() {
    if (!globalThemeInstance) {
        globalThemeInstance = useTheme();
    }
    return globalThemeInstance;
}
//# sourceMappingURL=composables.js.map